import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import placeholderAvatar from 'assets/images/icons/user_placeholder.svg'
import { addToast } from 'components/Toast/Toast'
import { type ISubscriptionHistoryItem } from 'types/interfaces/ITypes'

import styles from './mediaItemSmall.module.scss'

interface Props {
    active: boolean
    data: ISubscriptionHistoryItem
    clickFn: () => void
    blockedUserId?: string[]
    userData?: any
}

export const MediaItemSmall = ({
    active,
    data,
    clickFn,
    blockedUserId,
    userData
}: Props) => {
    const navigate = useNavigate()
    const { t } = useTranslation()

    // fallback gradient same as ProfileCover
    const coverStyle = {
        backgroundImage: data.coverSrc
            ? `url(${data.coverSrc})`
            : 'linear-gradient(135deg, #00cfd1, #09192d 40%, #8a003c, #ff003c)'
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.top} onClick={clickFn}>
                <div className={styles.cover} style={coverStyle}>
                    {!!data.newPosts && (
                        <div className={styles.count}>
                            <span>{data.newPosts}</span> {t('new')}
                        </div>
                    )}

                <div
                className={`${styles.avatar} ${
                    active ? styles.active : ''
                } ${
                    (!data.croppedAvatarSrc && !data.avatarSrc) ? styles.placeholder : ''
                }`}
                >
                <img
                    src={
                    data.croppedAvatarSrc ??
                    data.avatarSrc ??
                    placeholderAvatar
                    }
                    alt={t('avatar')}
                />
                </div>
                </div>
            </div>
            <div className={styles.bottom}>
                <div
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        if (
                            blockedUserId?.includes(data?.userId) &&
                            userData?.role === 'fan'
                        ) {
                            addToast('error', 'user is blocked you.')
                        } else {
                            navigate(`/${data.userName}`)
                        }
                    }}
                    className={styles.title}
                >
                    {data.userName}
                </div>
                <div className={styles.subTitle}>New Posts</div>
            </div>
        </div>
    )
}
